import React from 'react';
import PropTypes from 'prop-types';

// Components
import Hero from '../components/Hero/Hero';
import MicroLayout from '../layouts/Micro';
import SEO from '../components/SEO/SEO';
import TagList from '../components/Tag/TagList/TagList';

//  Utils
import titleCase from '../utils/titleCase';

const BlogTagsList = ({ pageContext, location }) => {
  const { categories } = pageContext;

  const allCategories = categories.map((category) => {
    const editedSlug = `/tags/${category.slug}`;
    return {
      name: titleCase(category.name),
      slug: category.slug,
      uri: `/blog${editedSlug}`,
    };
  });

  return (
    <MicroLayout>
      <SEO title="Tag Cloud" />
      <Hero title="Tag Cloud" location={location} crumbLabel="Tag Cloud" isNeedMainLabel={false} />
      <TagList allTags={allCategories} />
    </MicroLayout>
  );
};

BlogTagsList.propTypes = {
  props: PropTypes.object.isRequired, // eslint-disable-line
  location: PropTypes.instanceOf(BlogTagsList.props), // eslint-disable-line
  pageContext: PropTypes.instanceOf(BlogTagsList.props), // eslint-disable-line
};

export default BlogTagsList;
